import * as yup from 'yup';

export const schemaNps = yup.object().shape( {
  observation : yup.string(),
  value       : yup.string().required( 'Campo obrigatório' )
} );
